"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullBackRoleBonuses = exports.FullBackExpandedRoles = void 0;
// fullbackRoles.ts
const playerBonuses_1 = require("../playerBonuses");
const playerTraits_1 = require("../playerTraits");
const rarity_1 = require("../rarity");
const zones_1 = require("../zones");
const baseRoles_1 = require("./baseRoles");
var FullBackExpandedRoles;
(function (FullBackExpandedRoles) {
    // --- Uncommon --- GENERIC (Consistent with other positions)
    FullBackExpandedRoles["RAPID_FULL_BACK"] = "RAPID_FULL_BACK";
    FullBackExpandedRoles["POWERFUL_FULL_BACK"] = "POWERFUL_FULL_BACK";
    FullBackExpandedRoles["TIRELESS_FULL_BACK"] = "TIRELESS_FULL_BACK";
    FullBackExpandedRoles["DETERMINED_FULL_BACK"] = "DETERMINED_FULL_BACK";
    FullBackExpandedRoles["HEROIC_FULL_BACK"] = "HEROIC_FULL_BACK";
    FullBackExpandedRoles["ECCENTRIC_FULL_BACK"] = "ECCENTRIC_FULL_BACK";
    FullBackExpandedRoles["RELIABLE_FULL_BACK"] = "RELIABLE_FULL_BACK";
    FullBackExpandedRoles["LUCKY_FULL_BACK"] = "LUCKY_FULL_BACK";
    FullBackExpandedRoles["TENACIOUS_FULL_BACK"] = "TENACIOUS_FULL_BACK";
    FullBackExpandedRoles["INSPIRATIONAL_FULL_BACK"] = "INSPIRATIONAL_FULL_BACK";
    FullBackExpandedRoles["DOMINANT_FULL_BACK"] = "DOMINANT_FULL_BACK";
    FullBackExpandedRoles["IMPACT_FULL_BACK"] = "IMPACT_FULL_BACK";
    FullBackExpandedRoles["PRESSING_FULL_BACK"] = "PRESSING_FULL_BACK";
    FullBackExpandedRoles["STUBBORN_FULL_BACK"] = "STUBBORN_FULL_BACK";
    FullBackExpandedRoles["SHIELDING_FULL_BACK"] = "SHIELDING_FULL_BACK";
    FullBackExpandedRoles["VOCAL_FULL_BACK"] = "VOCAL_FULL_BACK";
    FullBackExpandedRoles["EXPERIENCED_FULL_BACK"] = "EXPERIENCED_FULL_BACK";
    FullBackExpandedRoles["FIREY_FULL_BACK"] = "FIREY_FULL_BACK";
    FullBackExpandedRoles["VERSATILE_FULL_BACK"] = "VERSATILE_FULL_BACK";
    // --- Uncommon --- FB SPECIFIC / FUNCTIONAL
    FullBackExpandedRoles["MARAUDING_FULL_BACK"] = "MARAUDING_FULL_BACK";
    FullBackExpandedRoles["WING_BACK"] = "WING_BACK";
    FullBackExpandedRoles["ORCHESTRATING_FULL_BACK"] = "ORCHESTRATING_FULL_BACK";
    FullBackExpandedRoles["SILKY_FULL_BACK"] = "SILKY_FULL_BACK";
    FullBackExpandedRoles["STAR_FULL_BACK"] = "STAR_FULL_BACK";
    FullBackExpandedRoles["ROAMING_FULL_BACK"] = "ROAMING_FULL_BACK";
    FullBackExpandedRoles["EXPERT_FULL_BACK"] = "EXPERT_FULL_BACK";
    FullBackExpandedRoles["COVERING_FULL_BACK"] = "COVERING_FULL_BACK";
    FullBackExpandedRoles["NO_NONSENSE_FULL_BACK"] = "NO_NONSENSE_FULL_BACK";
    FullBackExpandedRoles["RETENTIVE_FULL_BACK"] = "RETENTIVE_FULL_BACK";
    // --- Rare --- GENERIC COMBINATIONS (Two basic traits)
    FullBackExpandedRoles["ATHLETIC_FULL_BACK"] = "ATHLETIC_FULL_BACK";
    FullBackExpandedRoles["ENERGETIC_FULL_BACK"] = "ENERGETIC_FULL_BACK";
    FullBackExpandedRoles["VALIANT_FULL_BACK"] = "VALIANT_FULL_BACK";
    FullBackExpandedRoles["PLUCKY_FULL_BACK"] = "PLUCKY_FULL_BACK";
    FullBackExpandedRoles["ROBUST_FULL_BACK"] = "ROBUST_FULL_BACK";
    FullBackExpandedRoles["AGGRESSIVE_FULL_BACK"] = "AGGRESSIVE_FULL_BACK";
    FullBackExpandedRoles["COMMANDING_FULL_BACK"] = "COMMANDING_FULL_BACK";
    FullBackExpandedRoles["ROUSING_FULL_BACK"] = "ROUSING_FULL_BACK";
    // --- Rare --- ARCHETYPAL FULL BACKS / WING BACKS (Focus on Wing Back combinations)
    FullBackExpandedRoles["RAPID_WING_BACK"] = "RAPID_WING_BACK";
    FullBackExpandedRoles["ATTACKING_WING_BACK"] = "ATTACKING_WING_BACK";
    FullBackExpandedRoles["SOLID_DEFENDER"] = "SOLID_DEFENDER";
    FullBackExpandedRoles["TRADITIONAL_FULL_BACK"] = "TRADITIONAL_FULL_BACK";
    FullBackExpandedRoles["COMPLETE_FULL_BACK"] = "COMPLETE_FULL_BACK";
    FullBackExpandedRoles["INVERTED_FULL_BACK"] = "INVERTED_FULL_BACK";
    FullBackExpandedRoles["LAST_DITCH_DEFENDER"] = "LAST_DITCH_DEFENDER";
})(FullBackExpandedRoles || (exports.FullBackExpandedRoles = FullBackExpandedRoles = {}));
exports.FullBackRoleBonuses = {
    [baseRoles_1.BaseRoles.FULL_BACK]: {
        rarity: rarity_1.Rarity.COMMON,
        statBlock: {
            tackle: playerBonuses_1.PlayerBonuses.MAIN_POSITION_ATTRIBUTE,
            intercept: playerBonuses_1.PlayerBonuses.SECOND_POSITION_ATTRIBUTE,
            block: playerBonuses_1.PlayerBonuses.THIRD_POSITION_ATTRIBUTE,
        },
        positionsEnabled: [zones_1.Zones.DEFENSE, zones_1.Zones.MIDFIELD],
        playerTraits: [],
    },
    // --- Uncommon --- GENERIC ---
    [FullBackExpandedRoles.RAPID_FULL_BACK]: {
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.RAPID],
    },
    [FullBackExpandedRoles.POWERFUL_FULL_BACK]: {
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.POWERFUL],
    },
    [FullBackExpandedRoles.TIRELESS_FULL_BACK]: {
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.STAMINA],
    },
    [FullBackExpandedRoles.DETERMINED_FULL_BACK]: {
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.DETERMINED],
    },
    [FullBackExpandedRoles.HEROIC_FULL_BACK]: {
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Heroic tackles/blocks
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.HERO],
    },
    [FullBackExpandedRoles.ECCENTRIC_FULL_BACK]: {
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Flair runs
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.FLAIR],
    },
    [FullBackExpandedRoles.RELIABLE_FULL_BACK]: {
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Reliable positioning
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.RELIABLE],
    },
    [FullBackExpandedRoles.LUCKY_FULL_BACK]: {
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Lucky break for interception
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.LUCKY],
    },
    [FullBackExpandedRoles.TENACIOUS_FULL_BACK]: {
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.UNDERDOG],
    },
    [FullBackExpandedRoles.INSPIRATIONAL_FULL_BACK]: {
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Inspiring pass from the back
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.INSPIRE],
    },
    [FullBackExpandedRoles.DOMINANT_FULL_BACK]: {
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Dominant in the tackle
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.DOMINANT],
    },
    [FullBackExpandedRoles.IMPACT_FULL_BACK]: {
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Sub to solidify defence
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.SUPER_SUB],
    },
    [FullBackExpandedRoles.PRESSING_FULL_BACK]: {
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Good at pressing tackles
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.PRESSING], // Assuming trait exists
    },
    [FullBackExpandedRoles.STUBBORN_FULL_BACK]: {
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Unyielding blocks
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.UNYIELDING],
    },
    [FullBackExpandedRoles.SHIELDING_FULL_BACK]: {
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Shielding space
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.SHIELD],
    },
    [FullBackExpandedRoles.VOCAL_FULL_BACK]: {
        // Added for Traditional FB
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Good positioning
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.ORGANISED],
    },
    [FullBackExpandedRoles.EXPERIENCED_FULL_BACK]: {
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Wise positioning and reading of the game
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.WISE],
    },
    [FullBackExpandedRoles.FIREY_FULL_BACK]: {
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Firey tackles
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.IGNITE],
    },
    [FullBackExpandedRoles.VERSATILE_FULL_BACK]: {
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Boost to the 3rd position attribute (Block for FB)
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.VERSATILE],
    },
    [FullBackExpandedRoles.NO_NONSENSE_FULL_BACK]: {
        // Long ball
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Clear lines with long ball
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.LONG_BALL],
    },
    [FullBackExpandedRoles.RETENTIVE_FULL_BACK]: {
        // Ball retaining
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Keep ball under pressure
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.SECURE_POSSESSION],
    },
    // --- Uncommon --- FB SPECIFIC / FUNCTIONAL ---
    [FullBackExpandedRoles.MARAUDING_FULL_BACK]: {
        // Charge
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.CHARGE],
    },
    [FullBackExpandedRoles.WING_BACK]: {
        // Playmaker
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.PLAYMAKER],
    },
    [FullBackExpandedRoles.ORCHESTRATING_FULL_BACK]: {
        // Short Pass
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.SHORT_PASS],
    },
    [FullBackExpandedRoles.SILKY_FULL_BACK]: {
        // First Touch
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Technical passing
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.FIRST_TOUCH],
    },
    [FullBackExpandedRoles.STAR_FULL_BACK]: {
        // Star
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Star quality distribution
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.STAR],
    },
    [FullBackExpandedRoles.ROAMING_FULL_BACK]: {
        // Half Spaces
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Movement into space
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.HALF_SPACES],
    },
    [FullBackExpandedRoles.EXPERT_FULL_BACK]: {
        // Defensive Expert
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.DEFENSIVE_EXPERT], // Assuming trait exists
    },
    [FullBackExpandedRoles.COVERING_FULL_BACK]: {
        // Cover
        parentRoles: [baseRoles_1.BaseRoles.FULL_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.COVER], // Assuming trait exists
    },
    // --- Rare --- GENERIC COMBINATIONS ---
    [FullBackExpandedRoles.ATHLETIC_FULL_BACK]: {
        parentRoles: [
            FullBackExpandedRoles.RAPID_FULL_BACK,
            FullBackExpandedRoles.POWERFUL_FULL_BACK,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [FullBackExpandedRoles.ENERGETIC_FULL_BACK]: {
        parentRoles: [
            FullBackExpandedRoles.RAPID_FULL_BACK,
            FullBackExpandedRoles.TIRELESS_FULL_BACK,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [FullBackExpandedRoles.VALIANT_FULL_BACK]: {
        parentRoles: [
            FullBackExpandedRoles.DETERMINED_FULL_BACK,
            FullBackExpandedRoles.HEROIC_FULL_BACK,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [FullBackExpandedRoles.PLUCKY_FULL_BACK]: {
        parentRoles: [
            FullBackExpandedRoles.LUCKY_FULL_BACK,
            FullBackExpandedRoles.TENACIOUS_FULL_BACK,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [FullBackExpandedRoles.ROBUST_FULL_BACK]: {
        parentRoles: [
            FullBackExpandedRoles.TENACIOUS_FULL_BACK,
            FullBackExpandedRoles.POWERFUL_FULL_BACK,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [FullBackExpandedRoles.AGGRESSIVE_FULL_BACK]: {
        parentRoles: [
            FullBackExpandedRoles.TENACIOUS_FULL_BACK,
            FullBackExpandedRoles.RAPID_FULL_BACK,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Closing down quickly to tackle
        positionsEnabled: [],
        playerTraits: [],
    },
    [FullBackExpandedRoles.COMMANDING_FULL_BACK]: {
        parentRoles: [
            FullBackExpandedRoles.EXPERIENCED_FULL_BACK,
            FullBackExpandedRoles.VOCAL_FULL_BACK,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Wise and organised defensive presence
        positionsEnabled: [],
        playerTraits: [],
    },
    [FullBackExpandedRoles.ROUSING_FULL_BACK]: {
        parentRoles: [
            FullBackExpandedRoles.INSPIRATIONAL_FULL_BACK,
            FullBackExpandedRoles.DETERMINED_FULL_BACK,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    // --- Rare --- ARCHETYPAL FULL BACKS / WING BACKS ---
    [FullBackExpandedRoles.RAPID_WING_BACK]: {
        // Wing Back (Playmaker) + Rapid
        parentRoles: [
            FullBackExpandedRoles.WING_BACK,
            FullBackExpandedRoles.RAPID_FULL_BACK,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [FullBackExpandedRoles.ATTACKING_WING_BACK]: {
        // Marauding (Charge) + Wing Back (Playmaker)
        parentRoles: [
            FullBackExpandedRoles.MARAUDING_FULL_BACK,
            FullBackExpandedRoles.WING_BACK,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Focus on creating chances
        positionsEnabled: [],
        playerTraits: [],
    },
    [FullBackExpandedRoles.SOLID_DEFENDER]: {
        // Reliable + Expert
        parentRoles: [
            FullBackExpandedRoles.RELIABLE_FULL_BACK,
            FullBackExpandedRoles.EXPERT_FULL_BACK,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [FullBackExpandedRoles.TRADITIONAL_FULL_BACK]: {
        // Expert + Organised
        parentRoles: [
            FullBackExpandedRoles.EXPERT_FULL_BACK,
            FullBackExpandedRoles.VOCAL_FULL_BACK,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [FullBackExpandedRoles.COMPLETE_FULL_BACK]: {
        // Expert + Wing Back (Playmaker)
        parentRoles: [
            FullBackExpandedRoles.SHIELDING_FULL_BACK,
            FullBackExpandedRoles.RETENTIVE_FULL_BACK,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Balancing defence and creation
        positionsEnabled: [],
        playerTraits: [],
    },
    [FullBackExpandedRoles.INVERTED_FULL_BACK]: {
        // Shielding + Wing Back (Playmaker)
        parentRoles: [
            FullBackExpandedRoles.SHIELDING_FULL_BACK,
            FullBackExpandedRoles.WING_BACK,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Defensively sound when tucking in, creative outlet
        positionsEnabled: [],
        playerTraits: [],
    },
    [FullBackExpandedRoles.LAST_DITCH_DEFENDER]: {
        // Covering + Rapid
        parentRoles: [
            FullBackExpandedRoles.COVERING_FULL_BACK,
            FullBackExpandedRoles.RAPID_FULL_BACK,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Quick to cover space
        positionsEnabled: [],
        playerTraits: [],
    },
};
